import { z } from 'zod';

export const fundingApproverSchema = z.object({
    approverEmail: z
        .string()
        .trim()
        .min(1, "Enter the approver's email address")
        .email('Enter a valid email address'),
});

export type FundingApproverValues = z.infer<typeof fundingApproverSchema>;
